import SpecializationPage from "@/components/SpecializationPage";
import { IMG } from "@/lib/images";

export default function Ristrutturazioni() {
  return (
    <SpecializationPage
      testid="ristrutturazioni-page"
      quoteService="Ristrutturazione chiavi in mano"
      index="/ 01"
      title="Ristrutturazioni Chiavi in Mano"
      lines={["Ristrutturazioni", "chiavi in mano."]}
      subtitle="Un unico interlocutore per tutto il cantiere: dalla progettazione alla consegna. Gestiamo ogni fase con tempi certi, budget chiaro e qualità garantita."
      image={IMG.villa}
      accent="Il tuo progetto, gestito dall'inizio alla fine."
      intro={[
        "La ristrutturazione chiavi in mano ti solleva da ogni preoccupazione: coordiniamo noi tutte le lavorazioni, le maestranze e i fornitori, seguendo il cantiere in ogni sua fase. Tu segui l'avanzamento, noi ci occupiamo di tutto il resto.",
        "Dalla demolizione agli impianti, dalle opere murarie alle finiture, integriamo le nostre specializzazioni tecniche — impermeabilizzazione, coibentazione, efficientamento e rivestimenti — per un risultato durevole e a regola d'arte.",
      ]}
      specs={[
        { k: "Interlocutore", v: "Unico" },
        { k: "Preventivo", v: "Chiaro e dettagliato" },
        { k: "Tempi", v: "Certi e pianificati" },
        { k: "Direzione lavori", v: "Inclusa" },
        { k: "Pratiche", v: "Gestite da noi" },
        { k: "Finiture", v: "Su misura" },
      ]}
      benefits={[
        { t: "Un solo referente", d: "Coordiniamo tutte le imprese e i fornitori: nessuno scaricabarile, un solo responsabile." },
        { t: "Tempi e costi certi", d: "Cronoprogramma e computo definiti in anticipo, senza sorprese in corso d'opera." },
        { t: "Qualità garantita", d: "Materiali certificati e manodopera specializzata su ogni lavorazione." },
        { t: "Pratiche incluse", d: "Ci occupiamo di permessi, pratiche e gestione documentale del cantiere." },
        { t: "Tecnologie integrate", d: "Poliurea, poliuretano, fotovoltaico e rivestimenti in un unico progetto." },
        { t: "Chiavi in mano", d: "Ti consegniamo l'immobile pronto da vivere, pulito e finito." },
      ]}
      applications={[
        "Appartamenti e attici",
        "Ville e villette",
        "Case indipendenti e rustici",
        "Edifici plurifamiliari",
        "Ristrutturazioni totali",
        "Ristrutturazioni parziali",
        "Rifacimento bagni e cucine",
        "Rifacimento impianti",
        "Opere murarie e demolizioni",
        "Cappotti e coperture",
        "Cambi di destinazione d'uso",
        "Recupero sottotetti e mansarde",
        "Riqualificazione energetica",
        "Finiture e arredo su misura",
        "Immobili da mettere a reddito",
        "Seconde case e case vacanza",
      ]}
      faqs={[
        { q: "Cosa significa ristrutturazione chiavi in mano?", a: "Significa che un unico interlocutore coordina tutte le lavorazioni, le maestranze e i fornitori, seguendo il cantiere in ogni fase. Tu segui l'avanzamento, noi ci occupiamo di tutto il resto fino alla consegna dell'immobile finito." },
        { q: "I tempi e i costi sono definiti in anticipo?", a: "Sì. Prima dell'avvio condividiamo un preventivo chiaro e dettagliato e un cronoprogramma dei lavori, così da avere tempi certi e nessuna sorpresa in corso d'opera." },
        { q: "Vi occupate anche di permessi e pratiche?", a: "Sì. Gestiamo noi permessi, pratiche edilizie e documentazione del cantiere, sollevandoti dalla parte burocratica." },
        { q: "Gestite anche il problema dell'umidità di risalita?", a: "Sì. Il trattamento dell'umidità di risalita è integrato nel cantiere chiavi in mano, insieme alle finiture: interveniamo con un sistema di risanamento traspirante a basso spessore, senza demolizioni invasive." },
        { q: "Quali tecnologie integrate nel progetto?", a: "Integriamo le nostre specializzazioni tecniche: impermeabilizzazione in poliurea, coibentazione in poliuretano, efficientamento energetico, pareti ventilate e rivestimenti, per un risultato durevole e coordinato." },
      ]}
    />
  );
}
